<!--  轨迹完整分析页面  -->
<template>
    <div style="height: 100%;width: 100%">
        <div>
            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="value"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <van-icon name="replay" size="15px" @click="reststart"/><!-- icon图标，刷新页面 -->
                            </div>
                        </van-col>
                    </van-row>

                </div>
                <div>
                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="open"/>
                    </van-dropdown-menu>
                </div>
            </van-sticky>
        </div>

        <div style="background-color: #f8f8f9">
            <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                <!-- 上拉加载 -->
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                        :offset="400"
                >
                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>
                    <div v-for="(item,index) in list" class="content">
                        <Card style="width: 100%">
                            <cell size="small" style="padding: 0px;">
                                <label>车牌号/车架号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo.registrationNum==null?item.vehicleInfo.vin:item.vehicleInfo.registrationNum}}</label>
                                </label>
                            </cell>
                            <div class="mid">
                    <span class="count fl">终端主机号:
                        <label style="color: #0077aa;">{{item.terminalNum}}</label>
                    </span>
                            </div>

                            <div class="mid">
                    <span class="count fl">创建时间:
                        <label style="color: #0077aa;">{{new Date(item.createDatetime).Format('yyyy年MM月dd日')}}</label>
                    </span>
                            </div>
                            <div class="mid">
                                <span class="time fr">分析时间:
                        <label style="color: #0077aa;">{{new Date(item.analyzeDatetime).Format('yyyy年MM月dd日')}}</label>
                    </span>
                            </div>

                            <div class="mid">
                    <span class="count fl">连续里程:
                        <label style="color: #0077aa;">{{item.continuityMileage/10}}</label>
                    </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">总里程:
                        <label style="color: #0077aa;">{{item.allMileage/10}}</label>
                    </span>
                            </div>
                            <div class="mid">
                    <span class="count fl">轨迹完整率:
                        <label style="color: #0077aa;">{{item.tracksIntegrityPercent}}</label>
                    </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">上线率:
                        <label style="color: #0077aa;">{{item.onlinePercent}}</label>
                    </span>
                            </div>
                            <van-button size="small" type="info" @click="toBDmap(item)">查看覆盖图</van-button>
                        </Card>
                        <div style="height: 3px"></div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "tracksintegrityanalysiss",
        data() {
            return {
                list: [],
                value: '',
                value1: 0,
                option1: [
                    {text: '100%完整率', value: 0},
                    {text: '非100%完整率', value: 1},
                    {text: '100%上线率', value: 2},
                    {text: '非100%上线率', value: 3},
                ],
                isLoading: false,
                loader: false,

                loading: false,
                finished: false,

                i: [],
            }
        },
        methods: {
            toBDmap(e) {
                this.$router.push({
                    // name: 'BDmap',
                    // name: 'BDmap2',
                    name: 'QQMap',
                    params: {'item': e}
                })
            },
            onLoad() {
                this.i.push(1)
                console.log(this.i.length)
                // this.list = []

                if (this.value1 == 0) {
                    // setTimeout(() => {
                        let bb
                        let aa = []
                        aa.push(genQueryParam('tracksIntegrityPercent', 'EQ', 100))
                        //客户获取轨迹完整分析分页
                        store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: aa,
                                p: this.i.length,
                                keyword: this.value,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            console.log(res)
                            if (res.data.content.length != 0) {
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })
                    // }, 500);
                } else if (this.value1 == 1) {
                    // setTimeout(() => {
                        let bb
                        let aa = []
                        aa.push(genQueryParam('tracksIntegrityPercent', 'NEQ', 100))
                        //客户获取轨迹完整分析分页
                        store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: aa,
                                p: this.i.length,
                                keyword: this.value,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            console.log(res)
                            if (res.data.content.length != 0) {
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })
                    // }, 500);
                } else if (this.value1 == 2) {
                    // setTimeout(() => {
                        let bb
                        let aa = []
                        aa.push(genQueryParam('onlinePercent', 'EQ', 100))
                        //客户获取轨迹完整分析分页
                        store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: aa,
                                p: this.i.length,
                                keyword: this.value,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            console.log(res)
                            if (res.data.content.length != 0) {
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })
                    // }, 500);
                } else if (this.value1 == 3) {
                    // setTimeout(() => {
                        let bb
                        let aa = []
                        aa.push(genQueryParam('onlinePercent', 'NEQ', 100))
                        //客户获取轨迹完整分析分页
                        store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: aa,
                                p: this.i.length,
                                keyword: this.value,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            console.log(res)
                            if (res.data.content.length != 0) {
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })
                    // }, 500);
                }
            },
            refresh() {
                setTimeout(() => {
                    // this.onFind()
                    this.i=[]
                    this.list=[]
                    this.finished = false;
                    this.onLoad()
                    this.isLoading = false
                }, 500)
            },
            reststart() {
                this.loader = true
                setTimeout(() => {
                    // this.onFind()
                    this.i=[]
                    this.list=[]
                    this.finished = false;
                    this.onLoad()
                    this.loader = false
                }, 500);
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            // <!-- 下拉菜单方法 -->
            open(e) {
                this.i=[]
                this.list=[]
                this.finished = false;
              this.onLoad()
            },
            tracksIntegrityPercent100() {
                let aa = []
                aa.push(genQueryParam('tracksIntegrityPercent', 'EQ', 100))
                store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                    params: null,
                    urlparams: {
                        q: aa,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.list = res.data.content
                    this.loading = false
                }).catch((err) => {
                    console.log(err)
                })
            },
            tracksIntegrityPercentNo100() {
                let aa = []
                aa.push(genQueryParam('tracksIntegrityPercent', 'NEQ', 100))
                store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                    params: null,
                    urlparams: {
                        q: aa,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.list = res.data.content
                    this.loading = false
                }).catch((err) => {
                    console.log(err)
                })
            },
            onlinePercent100() {
                let aa = []
                aa.push(genQueryParam('onlinePercent', 'EQ', 100))
                store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                    params: null,
                    urlparams: {
                        q: aa,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.list = res.data.content
                    this.loading = false
                }).catch((err) => {
                    console.log(err)
                })
            },
            onlinePercentNo100() {
                let aa = []
                aa.push(genQueryParam('onlinePercent', 'NEQ', 100))
                store.dispatch('TracksIntegrityAnalysisServ_GetClientPage', {
                    params: null,
                    urlparams: {
                        q: aa,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.list = res.data.content
                    this.loading = false
                }).catch((err) => {
                    console.log(err)
                })
            },
            onFind() {
                this.i=[]
                this.list=[]
                this.finished = false;
                this.onLoad()
                // if (this.value1 == 0) {
                //     this.tracksIntegrityPercent100()
                // } else if (this.value1 == 1) {
                //     this.tracksIntegrityPercentNo100()
                // } else if (this.value1 == 2) {
                //     this.onlinePercent100()
                // } else if (this.value1 == 3) {
                //     this.onlinePercentNo100()
                // }
            },
        },
        mounted() {
            this.$nextTick(() => {


            })
        }
    }
</script>

<style scoped>
    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .conopen {
        text-align: right;
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 105px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }

    .loader {
        text-align: center;
    }
</style>
